import { FC } from 'react';
import cn from 'classnames';

import { DataButton, WebpImage } from 'components/Shared/SharedComponents';
import classes from 'src/styles/_commonClasses.module.scss';
import { PNG_TYPE } from 'constants/constants';

import styles from './styles.module.scss';

import type { IImage } from '../config/declarations';

const Image: FC<IImage> = ({
  imageObject,
  isMobileViewWidth,
  link,
  redirectToUrl,
}) => {
  const [desktop, mobile] = imageObject?.imagesCollection?.items || [];
  const image = isMobileViewWidth ? mobile : desktop;
  const onClick = () => redirectToUrl(link?.src);

  if (!image?.image) {
    return null;
  }

  const sourceImage = image.image.contentType === PNG_TYPE ? 'external' : image.image;
  const src = sourceImage === 'external' ? image.image.url : undefined;

  if (!link) {
    return (
      <div className={styles.bannerImageWrapper}>
        <WebpImage
          image={sourceImage}
          {...(src ? { src } : {})}
          className={styles.bannerImage}
          alt="Slide"
        />
      </div>
    );
  }

  return (
    <DataButton
      link={link!}
      onClick={onClick}
      onKeyDown={onClick}
      className={cn(classes.cursorPointer, styles.bannerImageWrapper)}
    >
      <WebpImage
        image={sourceImage}
        {...(src ? { src } : {})}
        className={styles.bannerImage}
        alt="Slide"
      />
    </DataButton>
  );
};

export default Image;
